exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-radio-group-button .ivu-radio-wrapper[data-v-ff9ac96a] {\n\tpadding: 0px 10px;\n}\n.areaunit[data-v-ff9ac96a] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n}\n.area[data-v-ff9ac96a] {\n\twidth: 110px;\n}\n", ""]);

// exports
